import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Photothumbnail from './Photothumbnail';

const ImageList = ({ currentPhotos, existingPhotos, removePhoto, }) => {
  const classes = useStyles();
  return (
    <div className={classes.imageContainer}>
      {existingPhotos.map((photo) => (<div className={classes.imageBox} key={photo.id}>
          <Photothumbnail
            id={photo.id}
            thumbUrl={photo.file.thumb.url}
            closeIconStyles={{ top: '-24px', right: '14px', }}
          />
        </div>))}
      {currentPhotos.map((photo, index) => (<div className={classes.imageBox} key={photo.name}>
          <div
            onClick={() => {
 removePhoto(index);
}}
            className={classes.close}
          />
          <img className={classes.singleImage} src={photo.file} alt={photo.name} />
        </div>))}
    </div>
  );
};


ImageList.defaultProps = {
  currentPhotos: [],
  existingPhotos: [],
  hashId: null,
};

ImageList.propTypes = {
  currentPhotos: PropTypes.arrayOf(PropTypes.object),
  existingPhotos: PropTypes.arrayOf(PropTypes.object),
  removePhoto: PropTypes.func.isRequired,
};

const useStyles = createUseStyles({
  imageContainer: {
    paddingLeft: '15px',
    marginTop: '2em',
    display: 'flex',
    flexWrap: 'wrap',
  },
  imageBox: {
    width: '110px',
    height: '140px',
    marginRight: '2px',
    position: 'relative',
  },
  singleImage: {
    borderRadius: '12px',
    width: '96px',
    height: '110px',
    marginTop: '6px',
  },
  close: {
    position: 'absolute',
    right: '8px',
    top: '-15px',
    width: '15px',
    height: '15px',
    cursor: 'pointer',
    opacity: '0.8',
    '&:hover': {
      opacity: '1',
    },
    '&:before': {
      content: '\'\'',
      position: 'absolute',
      left: '15px',
      height: '15px',
      width: '4px',
      backgroundColor: '#333',
      transform: 'rotate(45deg)',
    },
    '&:after': {
      content: '\'\'',
      position: 'absolute',
      left: '15px',
      height: '15px',
      width: '4px',
      backgroundColor: '#333',
      transform: 'rotate(-45deg)',
    },
  },
})
export default ImageList;

